import { Container, Grid, useMediaQuery } from '@material-ui/core';
import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';

import BlogCard from './BlogCard';
import SectionHeader from './SectionHeader';
import { cardList, cardItem, cardTap, cardHover, screenThreshold } from '../utils/animationVariants';
import { useInView } from 'react-intersection-observer';

const MotionGrid = motion(React.forwardRef((props, ref) => <Grid ref={ref} {...props} />));

const Blogs = ({ setActive, blogsData, location }) => {
	const isMdSmall = useMediaQuery((theme) => theme.breakpoints.down('md'));
	const isXsSmall = useMediaQuery((theme) => theme.breakpoints.down('xs'));

	const { ref, inView } = useInView({ threshold: isMdSmall ? '0.1' : 0.3 });
	const cardListVisible = useAnimation();
	const cardItemVisible = useAnimation();
	useEffect(
		() => {
			if (inView) {
				cardListVisible.start('visible');
				cardItemVisible.start('visible');
				setActive('/#blogs');
			}
			if (!inView) {
				cardListVisible.start('hidden');
				cardItemVisible.start('hidden');
			}
		},
		[ inView ]
	);
	return (
		<motion.section id="blogs" ref={ref}>
			<Container>
				<SectionHeader text="Blogs" inView={inView} />
				<MotionGrid
					container
					spacing={isMdSmall ? 3 : 2}
					justifyContent={isXsSmall ? 'center' : 'space-around'}
					alignItems="center"
					initial="hidden"
					animate={cardListVisible}
					variants={cardList}
				>
					{blogsData.map((article, i) => (
						<MotionGrid
							style={{ maxWidth: '340px' }}
							item
							md={4}
							sm={6}
							key={i}
							custom={i}
							initial="hidden"
							animate={cardItemVisible}
							variants={cardItem}
							whileHover={cardHover}
							whileTap={cardTap}
						>
							<BlogCard article={article} location={location} />
						</MotionGrid>
					))}
				</MotionGrid>
			</Container>
		</motion.section>
	);
};

export default Blogs;
